import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';
import orders from './sidebarItems/orders';
import helpcenter from './sidebarItems/helpcenter';

export const getSidebarItems = accountId => ({
  primaryMenu: primaryMenu(accountId),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    orders(accountId),
    reports(accountId),
    campaigns(accountId),
    helpcenter(accountId),
    settings(accountId),
    notifications(accountId),
  ],
});
